import { Entity, Column, PrimaryGeneratedColumn, Check, ManyToOne, JoinColumn } from 'typeorm'
import RespondentSurvey from './RespondentSurvey'

export enum RespondentSurveyState {
  INCOMPLETE = 'incomplete',
  COMPLETE = 'complete',
  RED_HERRING = 'red_herring',
  REJECTED_BY_DS = 'rejected_by_ds',
  APPROVED_BY_DS = 'approved_by_ds',
  REJECTED_BY_USER = 'rejected_by_user',
  APPROVED_BY_USER = 'approved_by_user'
}

@Entity('respondent_survey_events')
@Check(`CASE WHEN (state IN ('rejected_by_ds', 'approved_by_ds')) THEN filter_job_id IS NOT NULL ELSE TRUE END`)
@Check(`CASE WHEN (state IN ('rejected_by_user', 'approved_by_user')) THEN user_id IS NOT NULL ELSE TRUE END`)
@Check(`CASE WHEN state != 'rejected_by_user' THEN hide_from_clients IS NULL ELSE TRUE END`)
export default class RespondentSurveyEvent {
  @PrimaryGeneratedColumn('increment')
  id!: number

  @Column({ name: 'created_at' })
  createdAt!: Date

  @ManyToOne(type => RespondentSurvey, r => r.respondentSurveyEvents)
  @JoinColumn({ name: 'respondent_survey_id' })
  respondentSurvey!: RespondentSurvey

  @Column({
    name: 'state',
    type: 'enum',
    enum: RespondentSurveyState
  })
  respondentSurveyState!: RespondentSurveyState

  // TODO Setup foreign key when DS table migrations are managed by channel.
  @Column({ name: 'filter_job_id' })
  filterJobId?: string

  @Column({ name: 'user_id' })
  userId?: string

  @Column({ name: 'hide_from_clients' })
  hideFromClients?: boolean
}
